import React from 'react';

export const Header  = () => {
  return <h1>New albums & singles</h1>
};